'use strict';

const Backbone = require('backbone');
const Key = require('common/domain/value/key');

module.exports = Backbone.Model.extend({
    defaults: {
        actionKey: null,
        projectKey: null,
        projectName: ''
    },

    getActionKey: function() {
        return new Key(this.get('actionKey'));
    },

    getProjectKey: function() {
        return new Key(this.get('projectKey'));
    },

    getActionURL: function() {
        const projectKey = this.getProjectKey();
        const actionKey = this.getActionKey();
        return `/projects/${projectKey.id}/processes/${actionKey.id}`
    },

    getProjectURL: function() {
        const projectKey = this.getProjectKey();
        return `/projects/${projectKey.id}`
    },

    getProjectImageURL: function() {
        return this.get('projectImageURL');
    },

    getAssignees: function() {
        return this.get('assignees');
    },

    getEndAt: function() {
        return this.get('endAt');
    },

    getStateType: function() {
        return this.get('stateType');
    }
});



// WEBPACK FOOTER //
// ./balus/domain/entity/action-status.js